import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/system";
import { iff } from "@bryxinc/ts-utils";
import BryxColors from "../types/theme";
import { forwardRef } from "react";
function buildBoxProps(props) {
    let { sx, column, children, className, isFlex, isDashed, isSticky, hoverable, onClick, ...bbProps } = props;
    var bbProperties = {};
    Object.entries(bbProps).forEach((entry) => {
        const [bbPropKey, bbPropVal] = entry;
        const match = /[A-Z]\S+/.exec(bbPropKey);
        if (match === null || bbPropVal == false || bbPropVal == undefined)
            return;
        const prop = `${bbPropKey.slice(match.index, match.index + 1).toLowerCase()}${bbPropKey.slice(match.index + 1)}`;
        let propVal = `${bbPropKey.slice(0, match.index)}`;
        if (prop == "gap")
            propVal = { xs: "8px", sm: "16px", md: "24px", lg: "48px", xl: "64px" }[propVal];
        if (prop == "padding")
            propVal = { xs: "8px", sm: "16px", md: "24px", lg: "48px", xl: "64px" }[propVal];
        if (prop == "margin")
            propVal = { xs: "8px", sm: "16px", md: "24px", lg: "48px", xl: "64px" }[propVal];
        if (prop === "width" || prop == "height") {
            switch (propVal) {
                case "full":
                    propVal = "100%";
                    break;
                case "half":
                    propVal = "50%";
                    break;
            }
        }
        bbProperties[`${prop}`] = propVal;
    });
    sx = {
        backgroundImage: iff(isDashed, `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23737373FF' stroke-width='2' stroke-dasharray='16%2c 16' stroke-dashoffset='0' stroke-linecap='round'/%3e%3c/svg%3e")`),
        flexDirection: iff(column, "column"),
        position: iff(isSticky, "sticky"),
        zIndex: iff(isSticky, "999"),
        backgroundColor: iff(isSticky, BryxColors.background("light")),
        ...(hoverable && {
            ":hover:has(.MuiTypography-root):not(:focus-within)": {
                color: `${BryxColors.lightBrand(1)} !important`,
                borderColor: `${BryxColors.lightBrand(1)} !important`,
                ".MuiInputBase-root": {
                    color: `${BryxColors.lightBrand(1)} !important`,
                    borderColor: `${BryxColors.lightBrand(1)} !important`,
                },
            },
        }),
        ...sx,
    };
    return {
        display: isFlex ? "flex" : undefined,
        ...bbProperties,
        sx,
        children,
        className,
        onClick,
    };
}
const BryxBox = forwardRef((props, ref) => {
    return _jsx(Box, { ...buildBoxProps(props), ref: ref });
});
export default BryxBox;
